import React, {useEffect, useState} from "react"
import Pricebox from "@bodeboca/algolia/components/wineblock/pricebox"
import Rating from "@bodeboca/algolia/components/rating/rating"
import Critics from "@bodeboca/algolia/components/wineblock/critics"
import Tags from "@bodeboca/algolia/components/wineblock/tags"
import ApiService from "@bodeboca/api"
import CommonUtils from "@bodeboca/utils"
import './style.scss'
import {useTranslation} from "react-i18next"
import Ranking from "@bodeboca/algolia/components/wineblock/ranking"
import GtmApi from "@bodeboca/gtm/api"
import InsightsUtils from "@bodeboca/algolia/utils/insights"

const Product = ({hit, sendEvent, favourites, userFlaggedItems, availableBundlesToFlag}) => {
  const [isFavourite, setIsFavourite] = useState(hit.favourite)

  const queryId = hit["__queryID"]
  const imageUrl = hit["image_url"]
  // Temporal fallback to es.
  const languageInfo = hit[CommonUtils.getCurrentLanguage()] !== undefined ? hit[CommonUtils.getCurrentLanguage()] : hit['es']

  let path = getPath(hit, languageInfo)

  useEffect(() => {
    setIsFavourite(ApiService.isFavourite(hit['product_id']))
  }, [favourites])

  let styledImageUrl
  if (imageUrl) {
    styledImageUrl = imageUrl.replace('files/', 'files/styles/venta_retina/public/')
    styledImageUrl = styledImageUrl.replace('http://', 'https://')
  } else {
    styledImageUrl = '/sites/default/files/styles/venta_retina/public/externals/bot-silueta.jpg'
  }

  /**
   * Intercept href click event to set cookie before navigating.
   *
   * @param e - The href click event.
   */
  function goToProduct(e) {
    e.preventDefault() // Stop normal link behavior
    InsightsUtils.setQueryId(hit['product_id'], hit['__queryID'] )
    window.location.href = path
  }

  function getPath(hit, languageInfo) : string {

    // Legacy path.
    let path = hit['path']

    // Path when routing is enabled.
    if (ApiService.isRoutingEnabled() && languageInfo["prefix_path"] !== undefined) {
      if (languageInfo["prefix_path"] !== undefined) {
        path = languageInfo["prefix_path"]
      }
    }
    // Path when routing is disabled.
    else if (!ApiService.isRoutingEnabled() && languageInfo["path"] !== undefined) {
      path = languageInfo["path"]
    }
    return path
  }

  function toggleFavourite() {

    ApiService.toggleFavorite(hit['product_id'], isFavourite ? "remove" : "add")
      .then(() => {
        setIsFavourite(!isFavourite)
        if (!isFavourite) {
          sendEvent("conversion", hit, "Product added to favourites", {})
        }
      })
  }

  const {t} = useTranslation()

  return (<li className="ais-Hits-item wineblock">
    <div data-nid={hit['product_id']}>
      <Tags hit={hit}/>
      <div className="wineblock-inner">
        {ApiService.getUserId() !== 0 && <div
          className={"bb-favourites-ribbon icon bbicon-milistadedeseos " + (isFavourite ? "bb-favourites-favourite" : "")}
          title="Añadir a Favoritos"
          onClick={() => toggleFavourite()}/>}
        <a 
          className="wineimage bb-empathy-processed" 
          href={path} 
          onClick={goToProduct}>
          {hit['bio'] !== undefined &&
          <div className="certificate-wrapper">
            <span className="eco-icon">
              <img
                alt="Ecológico"
                height="15"
                src="/themes/custom/bodeboca/fonts/svg/icono-eco.svg"
                width="15"/>
            </span>
          </div>}
          <picture>
            <img
              alt={t('Product') + ': ' + languageInfo["title"]}
              className="imagecache imagecache-venta"
              loading="lazy"
              src={styledImageUrl} />
          </picture>
        </a>
        <div className="wineblock-info-wrapper">
          <div className="wineblock-info">
            <span
              className={"doyicon country-" + hit["country_id"]}
              title={hit["do"]}>
              {hit["do"] !== "" ? hit["do"] : hit["region"]}
            </span>
            <h2>
              <a 
                href={path} 
                title={languageInfo["title"]} 
                onClick={goToProduct}>
                {languageInfo.title}
              </a>
            </h2>
            <div className="format">{languageInfo.format}</div>
            <Critics critic={hit["main_critic"]}/>
          </div>
          <Pricebox
            availableBundlesToFlag={availableBundlesToFlag}
            hit={hit}
            path={path}
            sendEvent={sendEvent}
            userFlaggedItems={userFlaggedItems}/>
        </div>
        <Ranking hit={hit} />
        <Rating
          nid={hit["product_id"]}
          path={hit["path"]}
          queryId={queryId}
          ratingAverage={hit["rating_average"]}
          ratingCount={hit["rating_count"]}/>
      </div>
    </div>
  </li>)
}
export default Product
